import Auth_API from "./apiConfig"

export const getAllUsers = async (params) => {
    try {
      const response = await Auth_API.get('/connext/users', { params });
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  };
  
  export const getConnectedUsers = async (params) => {
    try {
      const response = await Auth_API.get('/connext/connected-users', { params });
      return response.data;
    } catch (error) {
      // Check if the error is from the server
      if (error.response) {
        // Server responded with a status other than 2xx
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        // Request was made but no response was received
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        // Something else happened while setting up the request
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  };
  
  export const receivedConnectionRequest = async (params) => {
    try {
      const response = await Auth_API.get('/connext/received-requests', { params });
      return response.data;
    }
    catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  }
  
  export const getSuggestedConnections = async (location,isRandom=false) => {
    try {
      const params = { location: [location], limit: 5,isRandom: isRandom };
      const response = await Auth_API.get('/connext/users', { params });
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  };
  
  export const getSentConnectionRequests = async (params) => {
    try {
      const response = await Auth_API.get('/connext/sent-requests', { params });
      return response.data;
    }
    catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  }
  
  export const sendConnectionRequest = async (recipientId,isProficorn) => {
    try {
      const response = await Auth_API.post(`/connext/send/${recipientId}?isProficorn=${isProficorn}`);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  };

  export const acceptConnectionRequest = async (connectionId,isProficorn) => {
    try {
      const response = await Auth_API.post(`/connext/accept/${connectionId}?isProficorn=${isProficorn}`);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  };
  
  export const connectionReject = async (connectionId,isProficorn) => {
    try {
      const response = await Auth_API.post(`/connext/reject/${connectionId}?isProficorn=${isProficorn}`);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  };

  export const connectionWithdraw = async (connectionId,isProficorn) => {

    // console.log(connectionId,"connectionId")
    try {
      const response = await Auth_API.post(`/connext/withdraw/${connectionId}?isProficorn=${isProficorn}`);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  };

  export const getAllAppointments = async (params) => {

    params.is_bazaar = false;
    try {
      const response = await Auth_API.get(`/appointment`,{params});
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  };
  

  export const appointmentAction = async (params) => {

    // console.log(params,"params appointmentAction ");
    try {
      const response = await Auth_API.post(`/appointment/action`,params);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  };
  
  export const getConnextAllLocations = async () => {
    try {
      const params = {page:1,limit:100000}
      const response = await Auth_API.get(`/locations`,{params});
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  };
  
  export const getAllConnextIndustries = async () => {
    try {
      const response = await Auth_API.get(`/industries`);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  };
  export const getAllConnextSubIndustries = async () => {
    try {
      const response = await Auth_API.get(`/sub-industries`);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  };
  
  export const getAllConnextNatureOfBusiness = async () => {
    try {
      const response = await Auth_API.get(`/nature-of-business`);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  };

  export const updateConnextTermsAndCondition = async (params) => {
  try {
    const response = await Auth_API.post('/connext/sent-requests/terms-and-conditions/update', params);
    return response.data;
  }
  catch (error) {
    if (error.response) {
      console.error("Server Error:", error.response.data.message || error.response.statusText);
      throw new Error(error.response.data.message || "Server Error");
    } else if (error.request) {
      console.error("Network Error:", error.message);
      throw new Error("Network Error. Please check your connection.");
    } else {
      console.error("Error:", error.message);
      throw new Error("An unexpected error occurred. Please try again."
        
      );
    }
  }
}

export const getFeedbackApi = async () => {
  try {
    const response = await Auth_API.get(`/user/proficorn-feedback-form/enabled`);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Server Error:", error.response.data.message || error.response.statusText);
      throw new Error(error.response.data.message || "Server Error");
    } else if (error.request) {
      console.error("Network Error:", error.message);
      throw new Error("Network Error. Please check your connection.");
    } else {
      console.error("Error:", error.message);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};

export const submitProficornFeedbackApi = async (params) => {
  try {
    const response = await Auth_API.post(`/user/proficorn/feedback/update`, params);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Server Error:", error.response.data.message || error.response.statusText);
      throw new Error(error.response.data.message || "Server Error");
    }
  }
};